import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";
import { useMemo } from "react";
import { KeywordBase, useGetKeywordBaseData } from "@api/useGetKeywordBaseData";
import { HOME_INDEX_METRICS_ORDER, MetricForTable, useMapMetricsForIndex } from "@models/Metric";

const REQUEST_PATH: keyof paths = '/api/Search/GetIndexes';
export type HomeTableIndexRequestPayload = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPageIndexesRequest"];
type ResponseData = components["schemas"]["FlavorTracker.Entities.DTO.SearchPage.SearchPageTableIndexesResponse"][];

export type HomeTableIndexDataItem = KeywordBase & {
    base: number;
    metrics: MetricForTable[];
}

export function useHomeTableIndexData(payload: HomeTableIndexRequestPayload) {
    const getKeywordBaseData = useGetKeywordBaseData();
    const mapMetricsForIndex = useMapMetricsForIndex(HOME_INDEX_METRICS_ORDER);

    const response = useAxios<ResponseData, HomeTableIndexRequestPayload>({
        url: REQUEST_PATH,
        method: 'post',
        payload,
    });

    const data = useMemo(
        (): HomeTableIndexDataItem[] => {
            return (response.data ?? []).map(item => {
                const itemBase = getKeywordBaseData(item.id ?? 0);

                return {
                    ...itemBase,
                    base: item.base ?? 0,
                    metrics: mapMetricsForIndex(structuredClone(item.metrics ?? [])),
                };
            });
        },
        [response.data, getKeywordBaseData, mapMetricsForIndex]
    );

    return {
        ...response,
        data,
    };
}